import { render, staticRenderFns } from "./SpinnerDots.vue?vue&type=template&id=9f59f94c&scoped=true"
import script from "./SpinnerDots.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerDots.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpinnerDots.vue?vue&type=style&index=0&id=9f59f94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f59f94c",
  null
  
)

export default component.exports